import { CompensationsValueObjectsEmployeeStatusEnum } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

export const VALID_EMPLOYEE_STATUSES: readonly CompensationsValueObjectsEmployeeStatusEnum[] = [
  'active',
  'inactive_this_month',
  'inactive_last_3_months',
] as const

export type CompensationsFilters = {
  legalEntityIds?: string[]
  teamIds?: string[]
  workplaceIds?: string[]
  validationTypes?: string[]
  integrationsAgreggatedSyncableStates?: string[]
  employeeStatus?: CompensationsValueObjectsEmployeeStatusEnum[]
}

export const employeeStatusFilterConfig = () => {
  const options: Record<CompensationsValueObjectsEmployeeStatusEnum, string> = {
    active: i18n.t('compensations.PayrollRunCompensationsList.filters.employeeStatusActive'),
    inactive_this_month: i18n.t(
      'compensations.PayrollRunCompensationsList.filters.employeeStatusInactiveThisMonth'
    ),
    inactive_last_3_months: i18n.t(
      'compensations.PayrollRunCompensationsList.filters.employeeStatusInactiveLast3Months'
    ),
  }

  return {
    employeeStatus: {
      label: i18n.t('compensations.PayrollRunCompensationsList.filters.employeeStatusLabel'),
      type: 'in' as const,
      options: {
        options: Object.entries(options).map(([value, label]) => ({
          label,
          value,
        })),
      },
    },
  }
}
